import React, { useEffect, useState, useCallback } from "react";
import { Drawer } from "rsuite";
import { useQuery } from "react-query";
import axios from "axios";
import style from "../style/DrawerComponent.module.scss";
import "../style/DrawerComponent.css";
import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import Timeline from "@mui/lab/Timeline";
import TimelineItem, { timelineItemClasses } from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import Typography from "@mui/material/Typography";
import ImageViewer from "react-simple-image-viewer";
import { Player } from "video-react";
import DOMPurify from "dompurify";
import "video-react/dist/video-react.css";
import Logger from "../libraries/Logger";
import apiClient from "../libraries/ApiClient";

const CssMessageButton = styled(Button)({
  fontSize: 16,
  borderColor: "#057AFF",
  backgroundColor: "#fff",
  padding: "8px 0px",
  margin: "16px 0px",
  width: "100%",
  "&:hover": {
    backgroundColor: "#1570EF",
    borderColor: "#fff",
    color: "#fff",
    cursor: "pointer",
  },
});

function DrawerComponent({ open, setOpen, noticeData }) {
  const navigate = useNavigate();
  const apiUrl = import.meta.env.VITE_API_ROOT_URL;
  const [token, setToken] = useState("");
  //console.log(noticeData);

  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const openImageViewer = useCallback((index) => {
    setCurrentImage(index);
    setIsViewerOpen(true);
  }, []);

  const closeImageViewer = () => {
    setCurrentImage(0);
    setIsViewerOpen(false);
  };

  useEffect(() => {
    //console.log(123);
    setToken(JSON.parse(localStorage.getItem("auth"))?.Token);
  }, []);

  const getNoticeData = async ({ queryKey }) => {
    if (queryKey[1] === "") {
      return null;
    }

    const [_, token] = queryKey;
    const data = JSON.stringify({
      Data: {},
    });
  };

  const getReferralDetail = async ({ queryKey }) => {
    const [_, rowId, token] = queryKey;
    const data = {
      Data: {
        RowId: rowId,
      },
    };

    const res = await apiClient.postAes("api/referral/Detail/Security", data);
    if (res?.status === 401) {
      alert("您的授權已失效，請重新登入");
      navigate("/Login");
      return null;
    }

    return res?.data;
  };


  return (
    <Drawer open={open} onClose={() => setOpen(false)}>
      <Drawer.Header>
        <Drawer.Title>最新一筆轉診者之留言</Drawer.Title>
      </Drawer.Header>
      <Drawer.Body>
        <div className={style.bodyTitle}>
          <div className={style.basic}>
            <div className={style.name}>{noticeData?.Name}</div>
            <div className={style.sex}>
              {noticeData?.Sex === 1 ? (
                <i className="fa-solid fa-mars"></i>
              ) : (
                ""
              )}
              {noticeData?.Sex === 2 ? (
                <i className="fa-solid fa-venus"></i>
              ) : (
                ""
              )}
            </div>
            <div>{noticeData?.Age}</div>
            <div>{noticeData?.Age === null ? "" : "歲"}</div>
          </div>
          <div>{noticeData?.CaseCode}</div>
          <div className={style.status}>
            <div
              style={{
                width: "12px",
                height: "12px",
                borderRadius: "50%",
                marginRight: "2px",
                backgroundColor: `${noticeData?.CaseStatus?.HexColor}`,
              }}
            ></div>
            <div>{noticeData?.CaseStatus?.Name}</div>
          </div>
        </div>
        <div>
          <CssMessageButton
            variant="outlined"
            onClick={() => {
              navigate(`/ReferralEditData?rowId=${noticeData?.RowId}#two`);
              setOpen(false);
            }}
          >
            留言
          </CssMessageButton>
        </div>
        <div className="timeLineBox">
          <Timeline
            sx={{
              [`& .${timelineItemClasses.root}:before`]: {
                flex: 0,
                padding: 0,
              },
            }}
          >
            {noticeData?.MessageParameters?.map((v, i) => {
              return (
                <TimelineItem key={i}>
                  <TimelineSeparator>
                    <TimelineDot />
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ py: "12px", px: 2 }}>
                    <Typography style={{ fontSize: "10px" }}>
                      {v.MessageUser}
                      <div
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(v.Content),
                        }}
                        style={{ fontSize: "10px" }}
                      ></div>
                    </Typography>
                    <Typography style={{ fontSize: "10px" }}>
                      {v.MessageDateTime}
                    </Typography>
                    <div style={{ width: "100%" }}>
                      {v.ImageUrls?.map(({ Url, RowId, FileRowId }) => ({
                        src: `${apiUrl}${Url}`,
                        rowId: RowId,
                        fileRowId: FileRowId,
                      }))?.map(({ src, rowId, fileRowId }, index) => (
                        <img
                          src={src}
                          key={fileRowId}
                          style={{ width: "200px" }}
                        ></img>
                      ))}
                    </div>

                    {v.VideoUrls?.map((v) => {
                      return `${apiUrl}${v}`;
                    })?.map((src, index) => (
                      <video controls className={style.video}>
                        <source src={src} type="video/mp4" />
                      </video>
                    ))}
                  </TimelineContent>
                </TimelineItem>
              );
            })}
          </Timeline>
        </div>
      </Drawer.Body>
    </Drawer>
  );
}

export default DrawerComponent;
